var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('h1',[_vm._v("个人设置页面")])])
}
var staticRenderFns = []

export { render, staticRenderFns }